/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetSpecialHourResponse
 */
export interface GetSpecialHourResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetSpecialHourResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetSpecialHourResponse
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSpecialHourResponse
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetSpecialHourResponse
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetSpecialHourResponse
     */
    notes: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetSpecialHourResponse
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetSpecialHourResponse
     */
    locationName: string | null;
}

/**
 * Check if a given object implements the GetSpecialHourResponse interface.
 */
export function instanceOfGetSpecialHourResponse(value: object): value is GetSpecialHourResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    return true;
}

export function GetSpecialHourResponseFromJSON(json: any): GetSpecialHourResponse {
    return GetSpecialHourResponseFromJSONTyped(json, false);
}

export function GetSpecialHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSpecialHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'date': (new Date(json['date'])),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'notes': json['notes'],
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'locationName': json['locationName'],
    };
}

export function GetSpecialHourResponseToJSON(json: any): GetSpecialHourResponse {
    return GetSpecialHourResponseToJSONTyped(json, false);
}

export function GetSpecialHourResponseToJSONTyped(value?: GetSpecialHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'date': value['date'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'notes': value['notes'],
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'locationName': value['locationName'],
    };
}

